import PropTypes from "prop-types";
import * as ColumnAlignment from "./ColumnAlignment";
import * as ColumnType from "./ColumnType";
export const columnPropType = PropTypes.shape({
  name: PropTypes.string,
  type: PropTypes.oneOf(Object.values(ColumnType)),
  label: PropTypes.string,
  format: PropTypes.func,
  component: PropTypes.func,
  alignment: PropTypes.oneOf(Object.values(ColumnAlignment)),
  clickDisabled: PropTypes.bool,
  className: PropTypes.string,
});
export const rowIdPropType = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
export const rowPropType = PropTypes.shape({
  id: rowIdPropType,
});
